import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import PreSignedUrlModel from "../../models/pre-signed-url";

export default class PreSignedUrlRepository extends BaseRepository {
  static modelClass = PreSignedUrlModel;
  modelName = "pre-signed-url";
}
